import Component from 'flarum/common/Component';
import { UploadActivity } from '../handler/Uploader';

/**
 * 上传活动横幅：显示在讨论页/首页顶部。
 *
 * 两种状态：
 * 1. 上传中：三段提示文案 + 进度条 + 当前文件
 * 2. 已上传完成：提示文字 + 关闭叉叉（手动 dismiss 后才消失）
 */
export default class UploadBanner extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    const activity = this.attrs.activity;

    // 上传中 → 显示进度横幅
    if (activity.isActive()) {
      const pct = activity.overallPct();
      return (
        <div className="UploadBanner" style="margin-bottom:15px">
          <div className="UploadBanner-inner">
            <div className="UploadBanner-head">
              <i className="icon fas fa-cloud-upload-alt" style="margin-right:8px;color:#e8a33d" />
              <span style="font-weight:bold;color:#fff">你有文件正在上传中，请勿离开此网站喵~</span>
              <button
                className="UploadBanner-cancel"
                style="margin-left:auto;background:none;border:1px solid rgba(255,255,255,.4);border-radius:3px;color:rgba(255,255,255,.85);cursor:pointer;font-size:12px;padding:2px 10px;margin-right:8px"
                onclick={() => {
                  const uploader = UploadActivity._activeUploader;
                  if (uploader) {
                    uploader.cancelAll();
                  } else {
                    activity.cancelAll();
                  }
                }}
                title="取消全部上传"
              >
                <i className="fas fa-times" style="margin-right:4px" />
                取消上传
              </button>
              <span className="UploadBanner-pct" style="color:#e8a33d;font-weight:bold">
                {pct}%
              </span>
            </div>

            <div className="UploadBanner-hint" style="margin-top:4px;font-size:12px;color:rgba(255,255,255,.85);line-height:1.7">
              <div>您可点击发布，上传任务在后台进行~，会自动插入到文章末尾~</div>
              <div style="color:rgba(255,255,255,.6)">
                若您需要在文章中间插入 那就老老实实等传完显示链接吧qcq
              </div>
            </div>

            <div
              className="UploadBanner-bar"
              style="margin:8px 0;height:6px;background:rgba(255,255,255,.15);border-radius:3px;overflow:hidden"
            >
              <div
                className="UploadBanner-bar-fill"
                style={`height:100%;width:${pct}%;background:linear-gradient(90deg,#e8a33d,#f0c060);transition:width .3s`}
              />
            </div>

            {activity.tasks.length > 0 && (
              <div className="UploadBanner-tasks" style="font-size:12px;color:rgba(255,255,255,.75)">
                {activity.tasks.map((t) => (
                  <div key={t.name + t.loaded} style="display:flex;justify-content:space-between">
                    <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:70%">
                      <i className="icon fas fa-circle-notch fa-spin" style="margin-right:6px" />
                      {t.name}
                    </span>
                    <span>{t.total > 0 ? `${(t.loaded / 1048576).toFixed(1)}/${(t.total / 1048576).toFixed(1)} MB` : '...'}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }

    // 已上传完成（本轮全部结束且用户未手动关闭）→ 完成态，需点叉叉才消失
    if (activity.isFinished()) {
      return (
        <div className="UploadBanner UploadBanner--done" style="margin-bottom:15px">
          <div className="UploadBanner-inner">
            <div className="UploadBanner-head">
              <i className="icon fas fa-check-circle" style="margin-right:8px;color:#7ed6a5" />
              <span style="font-weight:bold;color:#fff">您的文件已上传完成喵~</span>
              <button
                className="UploadBanner-close"
                style="margin-left:auto;background:none;border:none;color:rgba(255,255,255,.7);cursor:pointer;font-size:16px;padding:2px 6px"
                onclick={() => activity.dismissFinished()}
                title="关闭"
              >
                <i className="fas fa-times" />
              </button>
            </div>

            {activity.done.length > 0 && (
              <div className="UploadBanner-done" style="margin-top:6px">
                {activity.done.map((f, idx) => (
                  <div key={idx} style="font-size:12px;color:#7ed6a5;display:flex;align-items:center;margin-top:2px">
                    <i className="icon fas fa-check-circle" style="margin-right:6px" />
                    <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{f.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }

    // 无活跃上传、无完成态（被关闭或从未上传）
    return null;
  }
}
